import { IProduct } from "@/services/interfaces";
import { parseISO } from "date-fns";

export const calculateTotal = (product: IProduct, forceDiscount?: boolean, showPurchaseTotal?: boolean) => {
  try {
    const discounted = forceDiscount || isDiscounted(product);
    let { price, promo_price, quantity, promo_stock, stock } = product;
    price = product.purchase_price && showPurchaseTotal ? product.purchase_price : Number(product.price);
    promo_price = product.purchase_promo_price && showPurchaseTotal ? product.purchase_promo_price : Number(product.promo_price);
    if (!quantity) quantity = 1;

    if (!discounted && price) {
      return { totals: [(price as number) * (quantity || 1)] };
    } else if (price && promo_price) {
      if (quantity) {
        if (promo_stock && quantity > promo_stock) {
          const leftover = quantity - promo_stock;
          return {
            totals: [
              (price as number) * leftover,
              (promo_price as number) * promo_stock,
            ],
            left: leftover,
          };
        } else {
          return { totals: [(promo_price as number) * quantity] };
        }
      }
    }
    return { totals: [] };
  } catch (error) {
    console.warn(error);
    return { totals: [] };
  }
};

export const isDiscounted = (product: IProduct) => {
  return !!product.promo_price;
  const nowDate = new Date().getTime();
  let parsedEndDate;
  try {
    parsedEndDate = parseISO(product.promo_end as string);
  } catch (error) {
    console.warn(error);
  }

  if (!parsedEndDate || !product.promo_price) return false;

  const endDate = new Date(parsedEndDate).getTime();
  const diff = endDate - nowDate;

  return diff > 0;
};
